module.exports = __webpack_public_path__ + "static/2p-5bbfcdf18f56d266e87d300963d39f54.jpg";